import Pricing from "@/components/site/Pricing";

export default function PricingPage() {
  return <Pricing />;
}
